module.exports = __webpack_public_path__ + "img/upload_a_video.90d9acaf.jpg";